export default [
  {
    path: 'gmc-product-feeds',
    name: 'website.gmc.product-feeds',
    component: () => import('@/views/website/gmc/product-feeds'),
  },
  {
    path: 'gmc-product-feeds/create',
    name: 'website.gmc.product-feeds.create',
    component: () => import('@/views/website/gmc/product-feeds/Create'),
  },
  {
    path: 'gmc-product-feeds/update/:id',
    name: 'website.gmc.product-feeds.update',
    props: true,
    component: () => import('@/views/website/gmc/product-feeds/Update'),
  },
];
